<template>
	<div class="home">
		<div>
			<NavBar :nav="false" />
			<!-- <img src="@/assets/images/home_bg.png" class="bg" />
			<img src="@/assets/images/home_bg_2.png" class="bg2" /> -->
			<div class="content">
				<div class="title" v-if="datails.title">{{ datails.title }}</div>
				<div class="valueContent">
					<div class="vhtmlBox" v-if="datails.content" v-html="datails.content"></div>
					<div v-else class="empty">{{ loading ? '加载中...' : '暂无内容' }}</div>
				</div>
			</div>
			<div class="content video" v-if="datails.vide_path">
				<div class="title">相关视频</div>
				<div class="valueContent videobox" v-for="(item, index) in datails.vide_path" :key="index">
					<video :src="item.url" :poster="item.path" :autoplay="false" :controls="false" :loop="false" playsinline @click="lockVideo(item.url, item, index)">
						<!-- :poster="`${item.url}?x-oss-process=video/snapshot,t_1,f_jpg,w_715,h_380,m_fast,ar_auto`" -->
					</video>
					<img src="@/assets/images/play_2.png" class="play" @click.stop="lockVideo(item.url, item, index)" />
				</div>
			</div>
			<float-btn></float-btn>
			<!-- <video-play ref="video"></video-play> -->

			<!-- <video
				id="video_play"
				ref="video_play"
				:src="videoUrl"
				autoplay="true"
				controls="true"
				disablecontrols="false"
				@webkitfullscreenchange="fullscreenchange"
				@fullscreenchange="fullscreenchange"
			>
				<source :src="videoUrl" type="video/mp4" />
				<source :src="videoUrl" type="video/ogg" />
				<source :src="videoUrl" type="video/webm" />
				<object :data="videoUrl" width="100vw" height="100vh"><embed :src="videoUrl" width="100vw" height="100vh" /></object>
			</video> -->
		</div>
	</div>
</template>

<script>
import { Toast } from 'vant';
import Crypt from '@bluedot-tech/vue-ui/es/utils/crypt';
import config from '../config/config';
import floatBtn from '@/components/FloatBtn.vue';
// import VideoPlay from '@/components/Video.vue';
import NavBar from '@/components/NavBar.vue';

export default {
	components: {
		floatBtn,
		// VideoPlay,
		NavBar
	},
	data() {
		return {
			datails: {},
			loading: true
		};
	},
	created() {
		this.$loading.show();
	},
	mounted() {
		// 页面浏览 监测
		this.$dataStatistics({
			page_title: '近期活动'
		});
		this.getDetails();
		// // 环境变量获取方法
		// console.log('process.env', process.env);
	},
	methods: {
		lockVideo(url, item, index) {
			if (!url) return;

			this.$dataStatistics({ event_type: 'click', page_title: '近期活动' }, '观看视频');

			// this.playVedio(url);
			// this.$router.push({ path: '/video', query: { video: encodeURIComponent(url) } });
			this.$router.push({
				path: '/video',
				query: { video: encodeURIComponent(url), id: this.$route.query?.id }
			});
		},
		getDetails() {
			this.$loading.show();
			this.loading = true;
			this.$http.get(`/api/platform/module/${this.$route.query?.id}?filter[type]=2`).then((res) => {
				console.log('res', res);
				this.datails = res.data;
				if (this.datails.is_register == 1) {
					this.getUser();
				} else {
					this.loading = false;
					this.$loading.hide();
				}
			});
		},
		getUser() {
			this.$loading.show();
			this.$http.get(`/api/platform/user?source=${this.$route.query?.id}`).then((res) => {
				if (res.data.errcode == 500) {
					return;
				} else if (res.data.errcode == 1040) {
					this.$router.replace({ path: '/post-ls', query: { id: this.$route.query?.id, path: 'cibf' } });
					return;
				}
				this.$loading.hide();
			});
		}
		// playVedio(url) {
		// 	this.videoUrl = '';
		// 	this.$nextTick(() => {
		// 		this.videoUrl = url;

		// 		// 进入全屏状态
		// 		setTimeout(() => {
		// 			let video = document.getElementById('video_play');
		// 			// let video = this.$refs.video_play;
		// 			if (video.requestFullScreen) {
		// 				video.requestFullScreen();
		// 			} else if (video.webkitRequestFullScreen) {
		// 				// 在不支持 requestFullScreen 的浏览器上使用 webkitRequestFullScreen
		// 				video.webkitRequestFullScreen();
		// 			} else {
		// 			}
		// 		}, 0);
		// 	});

		// 	this.$dataStatistics({
		// 		page_title: '应用领域-观看视频'
		// 	});
		// },
		// fullscreenchange(e) {
		// 	// let video = this.$refs.video_play;
		// 	if (!document.fullscreenElement && !document.webkitFullscreenElement) {
		// 		let video = document.getElementById('video_play');
		// 		video.pause();
		// 		this.videoUrl = '';
		// 	}
		// }
		// onClick() {
		// 	this.$router.push('/about');
		// },
		// onSubmit() {
		// 	const crypt = new Crypt(config.crypto.publickey);
		// 	const email = '1198810568@qq.com';
		// 	const phone = '15812040230';
		// 	this.$http
		// 		.post('/xxx/xxx', {
		// 			first_name: '测试',
		// 			last_name: '3号',
		// 			phone: crypt.aes_encrypt(phone),
		// 			email: crypt.aes_encrypt(email),
		// 			crypt_key: crypt.rsa_key_encrypt()
		// 		})
		// 		.then(res => {
		// 			Toast('提交成功');
		// 		});
		// }
	}
};
</script>
<style lang="less" scoped>
.home {
	background: rgba(249, 247, 243, 0.66);

	.bg {
		position: fixed;
		top: 380px;
		left: 240px;
		z-index: 4;
		transform: translateX(-100%) translateY(-100%);
		display: block;
		width: 412px;
		height: 415px;
	}

	.bg2 {
		position: fixed;
		right: 399px;
		top: 839px;
		z-index: 4;
		transform: translateX(100%);
		display: block;
		width: 561px;
		height: 564px;
	}

	.title {
		padding-left: 30px;
		font-size: 32px;
		font-weight: normal;
		color: #000000;
		line-height: 1.5;
		position: relative;
		margin-bottom: calc(30px - ((32px * 1.5 - 32px) / 2));
		-webkit-text-stroke: 0.6px;
		&::before {
			content: '';
			display: block;
			position: absolute;
			top: 50%;
			left: 0;
			transform: translateY(-50%);
			z-index: 1;
			width: 10px;
			height: 30px;
			background: #a74499;
		}
	}

	.content {
		width: 100%;
		padding: 30px 27px;
		position: relative;
		overflow-y: auto;
		height: auto;
		z-index: 6;

		.videobox {
			margin-bottom: 41px;
		}

		.valueContent {
			position: relative;
			padding: 28px 32px;
			background: rgba(255, 255, 255, 0.6);
			box-shadow: 0px -9px 65px 0px rgba(0, 0, 0, 0.13);
			white-space: pre-wrap;
			word-wrap: break-word;
			word-break: break-all;

			/deep/img,
			img {
				max-width: 100%;
			}

			.play {
				width: 80px;
				height: 80px;
				display: block;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translateX(-50%) translateY(-50%);
				z-index: 333;
			}
		}
	}
}
</style>
